import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { BaseObject } from './BaseObject';

/**
 * Formats a payment month
 * @param {any} year
 * @param {any} month
 */
export function formatPaymentMonth(year, month) {
    if (month > 9) {
        return year + '-' + month;
    } else {
        return year + '-0' + month;
    }
}

export class PaymentRound extends BaseObject {
    constructor(obj) {
        super();

        if (_.isObjectLike(obj)) {
            _.assign(this, obj);

            this.PaymentMonth = formatPaymentMonth(this.Year, this.Month);
            this.VersionDate = utility.parseDate(this.VersionDate);
            this.MeetingDateFirst = utility.parseDate(this.MeetingDateFirst);
            this.MeetingDateLast = utility.parseDate(this.MeetingDateLast);
            this.FileDate = utility.parseDate(this.FileDate);
        }
    }
}
